module.exports = __webpack_public_path__ + "img/icons.90c0ac3c.svg";